import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function FaqSection({ items }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="divide-y divide-white/[0.07] border-y border-white/[0.07]">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} data-testid="faq-accordion-item">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="group flex w-full items-center justify-between gap-6 py-6 text-left"
            >
              <span
                className={`font-display text-lg transition-colors duration-300 sm:text-xl ${
                  isOpen
                    ? "text-[#A78BFA]"
                    : "text-[#F0F2F8] group-hover:text-[#A78BFA]"
                }`}
              >
                {item.q}
              </span>
              <Plus
                className={`h-4 w-4 shrink-0 text-[#8B5CF6] transition-transform duration-300 ${
                  isOpen ? "rotate-45" : ""
                }`}
              />
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="body-muted max-w-3xl pb-6 pr-10 text-sm sm:text-base">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
